import { ApiService } from "./api.service";
import { Router } from "@angular/router";

import { Injectable } from '@angular/core';
import { PushNotifModel, PushNotifFilterModel } from "../models";
//import { Observable, of } from 'rxjs';
import { IResponse } from "@bt/shared";

@Injectable()
export class PushNotifSectionService{

    constructor(private api: ApiService,
                private router: Router,){}

    public GetPushNotif(pushNotifFilterModel: PushNotifFilterModel): Promise<IResponse<PushNotifModel[]>>{
        return this.api.post<PushNotifModel[]>("api/pushnotification/getpushnotif", pushNotifFilterModel).toPromise();
    }


}


// WEBPACK FOOTER //
// ./src/app/core/services/push-notif-section.service.ts